export const NLPConfigurationEnum = {
  SECURITY_LEVELS: {
    STRICT: "strict",
    DEFAULT: "default", 
    LENIENT: "lenient"
  },
  
  SECURITY_LEVEL_LABELS: {
    STRICT: "Strict",
    DEFAULT: "Default",
    LENIENT: "Lenient"
  },
  
  SECURITY_LEVEL_DESCRIPTIONS: {
    STRICT: "Maximum security with strict validation",
    DEFAULT: "Balanced security and performance",
    LENIENT: "Relaxed security for faster processing"
  }
}; 